import { Reveal } from "./Reveal";

export const MemberCard = ({ member, index }) => (
  <Reveal delay={index * 0.12}>
    <article data-testid={`member-card-${index}`} className="group">
      <div className="aspect-[3/4] overflow-hidden border border-ink bg-secondary">
        <img
          src={member.photo}
          alt={`Ritratto di ${member.name}`}
          loading="lazy"
          className="h-full w-full object-cover grayscale transition-[transform,filter] duration-700 ease-out group-hover:scale-[1.04] group-hover:grayscale-0"
        />
      </div>
      <h3 className="mt-5 font-oswald text-2xl font-semibold uppercase tracking-tight">{member.name}</h3>
      <p className="mt-1 font-oswald text-sm uppercase tracking-[0.2em] text-orange">{member.role}</p>
      <p className="mt-3 max-w-xs text-sm leading-relaxed opacity-80">{member.bio}</p>
    </article>
  </Reveal>
);
